import React from 'react';
import PropTypes from 'prop-types';
import DefaultButton from 'components/Utils/NewDefaultButton';
import RouteUtils from 'services/RouteUtils';
import DefaultConfirmationModal from 'components/Utils/DefaultConfirmationScreen';
import { useNavStack } from 'careand-redux/slices/ui/hooks';
import { Stacks } from 'careand-redux/slices/ui/navigation';

const ScheduleButton = ({ hide, style }) => {
  const nav = useNavStack(Stacks.Master);

  function goToSchedule() {
    nav.push(RouteUtils.getRoute(RouteUtils.routes().book));
  }

  let name = 'Schedule an Appointment';

  return (
    <DefaultButton
      id="schedule-button"
      name={name}
      icon="calendar-clock"
      style={style || { width: '250px', margin: 'auto', marginTop: '15px' }}
      hide={hide}
      onClick={goToSchedule}
    />
  );
};

export const TITLE = 'Subscription';
export const MESSAGE =
  'Your current subscription does not include this type of appointment. Would you like to know more about all of our services?';

export const SubscribeDialog = ({
  open = false,
  title = TITLE,
  message = MESSAGE,
  onConfirm,
  onCancel,
}) => (
  <DefaultConfirmationModal
    open={open}
    onCancel={onCancel}
    onConfirm={onConfirm}
    title={title}
    text={message}
    icon="circle-calendar"
    confirmLabel="Find Out More"
    cancelLabel="Go back"
  />
);

ScheduleButton.propTypes = {
  hide: PropTypes.bool,
  style: PropTypes.object,
};

export default ScheduleButton;
